var map = {
	"./BusinessGrey.svg": 2297,
	"./BusinessWhite.svg": 6844,
	"./IndividualGrey.svg": 8403,
	"./IndividualWhite.svg": 3574,
	"./LoginSuccess.svg": 9966,
	"./LogoWhite.svg": 3168,
	"./MenuIcon.svg": 6746,
	"./MerchantIcon.svg": 7083,
	"./PendingMessageVector.svg": 5141,
	"./RP_Logo-01.svg": 2012,
	"./UserIcon.svg": 2150,
	"./Vector.svg": 3386,
	"./adminMerchantIcon.svg": 8272,
	"./adminUserIcon.svg": 4191,
	"./circle.svg": 4217,
	"./createOutline.svg": 6185,
	"./dark/bank.svg": 5820,
	"./dark/google.svg": 1563,
	"./dark/logo.svg": 5404,
	"./dark/mail.svg": 5068,
	"./dark/malaysia.svg": 5382,
	"./dark/phone.svg": 167,
	"./dark/rpSignIn.svg": 7197,
	"./filter.svg": 5535,
	"./form.svg": 3833,
	"./id.svg": 2420,
	"./image.svg": 7221,
	"./imageloading.svg": 6757,
	"./light/bank.svg": 9280,
	"./light/google.svg": 2955,
	"./light/logo.svg": 9398,
	"./light/mail.svg": 560,
	"./light/malaysia.svg": 9954,
	"./light/person.svg": 9968,
	"./light/phone.svg": 8193,
	"./light/rpSignIn.svg": 827,
	"./linkBank.svg": 4460,
	"./loginVector.svg": 8086,
	"./mykad.svg": 4965,
	"./office.svg": 1982,
	"./passport.svg": 3722,
	"./person.svg": 6814,
	"./personal.svg": 5318,
	"./profileImg.svg": 1,
	"./selfie.svg": 2563,
	"./ssm.svg": 8708,
	"./uploadIcon.svg": 7151,
	"./verification.svg": 3288
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6057;